export default __webpack_public_path__ + "static/char-s-21-en-57a85270815cc35acc7538590eaa0b27.png";